import Cell from "@/classes/Cell";
import {every} from 'lodash';
export default class CellCollection {
    _cells: Cell[];

    constructor(cells: Cell[]) {
        this._cells = cells;
    }

    isSolved(): boolean {
        return every(this._cells, cell => cell.is_solved);
    }

    get cells(): Cell[] {
        return this._cells
    }
}